import type { CalculatedAttributesCollector } from '../../calculatedAttributes/collect';
import type { ComponentSimilarProducts } from './types';

/**
 * Similar Products draws a grid of products against a chosen set of attributes.
 * The set is authored for the whole module, not per product, so every product
 * it lists needs a figure for every calculated attribute among them
 * (CMS-1890 / CMS-1786) — one group.
 *
 * The module has no mode, so it states no vertical and the page's stands in.
 */
export const collectSimilarProductsCalculatedAttributes: CalculatedAttributesCollector<
  ComponentSimilarProducts
> = (component) => ({
  groups: [
    {
      productIds: (component.products ?? [])
        .map((item) => item?.product?.title)
        .filter((title): title is string => !!title),
      attributeNames: (component.attributes ?? []).map(
        (row) => row?.attribute?.name,
      ),
    },
  ],
});
